import { connect } from 'react-redux';

import CaseList from 'components/app-case/case-list';
const mapStateToProps = (state, ownProps) => {
  const list = state.caseList;
  return { list, ...ownProps };
};

export default connect(
  mapStateToProps,
  null
)(CaseList);
